import { contains, has } from 'ramda';
import { combineReducers } from 'redux';
import {
  AUTH_GRANTED,
  SKIP_LOGIN,
} from '../actions';

const visibilityFunctions = {
  NAVIGATION_ITEM_ACCOUNTS: user => contains(user.type, [
    'editor',
    'master',
    'director',
    'base',
  ]),
  NAVIGATION_ITEM_ACCOUNTS_CLIENTS: user => contains(user.type, ['editor']) || user.isClient,
  NAVIGATION_ITEM_ACCOUNTS_NON_CLIENTS: user => contains(user.type, ['editor']) || !user.isClient,
  NAVIGATION_ITEM_ACCOUNTS_NON_EDITORS: user => contains(user.type, ['editor']),
  NAVIGATION_ITEM_COMPANIES: user => contains(user.type, ['editor']),
  NAVIGATION_ITEM_COMPANY: user => contains(user.type, ['master',
    'director',
    'buyer',
    'base',
  ]),
  NAVIGATION_ITEM_ORDERS: user => contains(user.type, [
    'editor',
    'master',
    'director',
    'buyer',
  ]),
};

const stateFunctions = {
  NAVIGATION_ITEM_ACCOUNTS_CLIENTS: () => 'authenticated.accounts',
  NAVIGATION_ITEM_ACCOUNTS_NON_CLIENTS: () => 'authenticated.accounts',
  NAVIGATION_ITEM_ACCOUNTS_NON_EDITORS: () => 'authenticated.accounts',
  NAVIGATION_ITEM_COMPANIES: () => 'authenticated.company.search',
  NAVIGATION_ITEM_COMPANY: user => `authenticated.company.detail.documents({ id: '${user.companyId}' })`,
  NAVIGATION_ITEM_ORDERS: () => 'authenticated.orders',
};

const initialState = [
  {
    title: 'NAVIGATION_ITEM_ACCOUNTS',
    visible: false,
    dd: [
      {
        text: 'NAVIGATION_ITEM_ACCOUNTS_CLIENTS',
        state: 'authenticated.accounts',
        params: { clients: true, editor: false },
        visible: false,
      },
      {
        text: 'NAVIGATION_ITEM_ACCOUNTS_NON_CLIENTS',
        state: 'authenticated.accounts',
        params: { clients: false, editor: false },
        visible: false,
      },
      {
        text: 'NAVIGATION_ITEM_ACCOUNTS_NON_EDITORS',
        state: 'authenticated.accounts',
        params: { clients: false, editor: true },
        visible: false,
      },
    ],
  },
  {
    title: 'NAVIGATION_ITEM_COMPANIES',
    state: undefined,
    visible: false,
  },
  {
    title: 'NAVIGATION_ITEM_COMPANY',
    state: undefined,
    visible: false,
  },
  {
    title: 'NAVIGATION_ITEM_ORDERS',
    visible: false,
    state: 'authenticated.orders',
  },
];

const getPagesPerUser = user => initialState.map((page) => {
  const newPage = Object.assign({}, page, { visible: visibilityFunctions[page.title](user) });

  if (has('dd', page)) {
    newPage.dd = page.dd.map(section => Object.assign({}, section, {
      visible: visibilityFunctions[section.text](user),
      state: stateFunctions[section.text](user),
    }));
  }

  if (has('state', page)) {
    newPage.state = stateFunctions[page.title](user);
  }

  return newPage;
});

const getHomeForUser = (user) => {
  switch (user.type) {
    case 'editor':
    case 'master':
    case 'director':
    case 'buyer':
      return {
        state: 'authenticated.home',
        params: {},
      };
    default:
      return {
        state: 'authenticated.company.detail.documents',
        params: { id: user.companyId },
      };
  }
};

function pages(state = initialState, action) {
  switch (action.type) {
    case AUTH_GRANTED:
    case SKIP_LOGIN:
      return getPagesPerUser(action.user);
    default:
      return Object.assign([], state);
  }
}

function home(state = 'authenticated.home', action) {
  switch (action.type) {
    case AUTH_GRANTED:
    case SKIP_LOGIN:
      return getHomeForUser(action.user);
    default:
      return state;
  }
}

const navigation = combineReducers({
  home,
  pages,
});

export default navigation;
